import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center justify-center w-full" }
const _hoisted_2 = { class: "flex flex-col items-center justify-center gap-3 pt-5 pb-6" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "mb-2 text-sm" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Click para subir archivo"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" o arrastra el fichero aquí. ")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs" }, "JPG (MAX. 800x400px) or PDF", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_mdicon = _resolveComponent("mdicon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", {
      for: "dropzone-file",
      onDragenter: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.switcActivationDropzone && _ctx.switcActivationDropzone(...args)), ["prevent"])),
      onDragleave: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.switcActivationDropzone && _ctx.switcActivationDropzone(...args)), ["prevent"])),
      onDragover: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"])),
      onDrop: _cache[4] || (_cache[4] = _withModifiers((event)=>_ctx.inputFileHandler(event, true), ["prevent"])),
      class: _normalizeClass([{ 'bg-button-green/80 text-white': _ctx.activeDropzone }, "flex flex-col items-center hover:bg-button-green/80 transition-all hover:text-white justify-center w-full h-64 border-2 border-dashed rounded-lg cursor-pointer dark:border-gray-600"])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_mdicon, {
          name: "file-document-multiple",
          size: "45"
        }),
        _hoisted_3,
        _hoisted_4
      ]),
      _createElementVNode("input", {
        id: "dropzone-file",
        type: "file",
        class: "hidden",
        accept: ".pdf,.jpg",
        onChange: _cache[0] || (_cache[0] = (event)=>_ctx.inputFileHandler(event))
      }, null, 32)
    ], 34)
  ]))
}